import { PageHeader, UserDetailView, useAuth } from "@nexys/user-management-web";
import { ArrowLeft } from "lucide-react";
import { Link, Navigate, useNavigate, useParams } from "react-router-dom";

export const UserDetailPage = () => {
  const { hasUserRole } = useAuth();
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  if (!hasUserRole("superadmin", "useradmin")) {
    return <Navigate to="/" replace />;
  }
  if (!id) {
    return <Navigate to="/users" replace />;
  }

  return (
    <div className="grid gap-6">
      <div className="grid gap-2">
        <Link
          to="/users"
          className="flex w-fit items-center gap-1 text-sm text-muted-foreground hover:text-foreground"
        >
          <ArrowLeft className="size-4" />
          All users
        </Link>
        <PageHeader
          title="User details"
          description="Profile, access, sign-in methods and tenant memberships."
        />
      </div>
      <UserDetailView
        userId={id}
        onDeleted={() => navigate("/users", { replace: true })}
      />
    </div>
  );
};
